import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AztecScannerStep} from '../../../enums/next/aztec-scanner-step.enum';
import {AztecScannerResult} from '../../../enums/next/aztec-scanner-result.enum';
import {AztecScannerAction} from '../../../enums/next/aztec-scanner-action.enum';
import {NextAztecScannerService} from '../../../services/next-aztec-scanner.service';

@Component({
  selector: 'app-next-aztec-scanner',
  templateUrl: './next-aztec-scanner.component.html',
  styleUrls: []
})
export class NextAztecScannerComponent implements OnInit {

  ScannerStep = AztecScannerStep;
  currentStep = AztecScannerStep.SCANNER;
  aztecScannerResult: AztecScannerResult;

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() result: EventEmitter<AztecScannerResult> = new EventEmitter<AztecScannerResult>();

  constructor(private aztecScannerService: NextAztecScannerService) {

  }

  ngOnInit(): void {
    this.aztecScannerService.aztecScannerResult$.subscribe(result => {
      this.aztecScannerResult = result;
      if (this.aztecScannerResult === AztecScannerResult.ERROR) {
        this.changeStep(AztecScannerStep.NOTIFICATION);
      } else {
        this.closeScanner(true);
      }
    });
  }

  handleAction(action: any): void {
    switch (action) {
      case AztecScannerAction.SCAN:
        this.changeStep(AztecScannerStep.SCANNER);
        break;
      case AztecScannerAction.CANCEL_SCANNING:
        this.closeScanner(false);
        break;
      default:
        console.log('not supported');
    }
  }

  closeScanner(success: boolean) {
    this.close.emit(success);
  }

  private changeStep(step: AztecScannerStep): void {
    this.currentStep = step;
  }

}
